export const chemicalData = [
    'CH3COOH',
    'HCl',
    'H2SO4',
    'CH3COO–',
    'NH3',
    'HNO3',
    'H3PO4',
    'Na3PO4',
    'CaCO3',
    'NH4NO3',
    'H2CO3',
    'NaHCO3',
    'NaOH',
    'Ca(OH)2',
    'C2H5OH',
    'HBr',
    'HNO2',
    'KOH',
    'AgNO3',
    'Na2CO3',
    'NaCl',
    '(C6H10O5)n',
    'Mg(OH)2',
    'CH4',
    'NO2',
    'NaNO3',
    'H2SO3',
    'Al2(SO4)3',
    'Al2O3',
    'NH4NO3',
    '(NH4)3PO4',
    'Ba(OH)2',
    'CCl4',
    'C6H8O7',
    'HCN',
    'C7H6O3',
    'HI',
    'HClO',
    'Fe2O3',
    'Mg3(PO4)2',
    'C2H3NaO2',
    'Na2SO4',
    'C12H22O11',
    'KNO3',
    'NH4HCO3',
    'NH4Cl',
    'NH4OH',
    'Ca(NO3)2',
    'CaO',
    'CO',
    'Cl2',
    'C6H6O',
    'H2O2',
    'OH–',
    'MgCl2',
    'KCl',
    'KI',
    'SO2',
    'C3H8O3',
    'Ba(NO3)2',
    'C4H6O4Ca',
    'Fe2O3',
    'K2CO3',
    'AgCl',
    'NaI',
    'Na2O',
    'Na2S',
    'Zn(NO3)2',
    'C20H14O4',
    'Mg(NO3)2',
    'SiO2',
    'C3H6O',
    'C6H6O2',
    'C5H5N',
    'C8H10',
    'BaSO4',
    'C6H6',
    'CHO3–',
    'CrO42-',
    'C4H8O',
    'CN−',
    'C2HCl3O2',
    'MgSO4',
    'CH3OH',
    'O',
    'C16H18ClN3S',
    'Na2SO3',
    'SO3',
    'AlPO4',
    'C18H36O2',
    'N2O',
    'TiO2',
    'C2H3N',
    'H2C2O4',
    'K2Cr2O7',
    'NaBr',
    'NaClO',
    'Zn(CH3COO)2(H2O)2',
    'ZnCl2',
    'Zn(OH)2',
    'MgCO3',
    'KClO3',
    'N2H4',
    'C6H8O6',
    'C7H6O2',
    'C6H6O2',
    'Cl2',
    'C4H4O4',
    'Na2S2O5',
    'C2H5NO',
    '(Na2O)x·SiO2',
    'NO2−',
    'CH2Cl2',
    'CS2',
    'CrK2O4',
    'ZnSO4',
    'I',
    'C76H52O46',
    'Al',
    'HClO4',
    'ClO–',
    'KBr',
    'H2CrO4',
    'OH2',
    'C3H6O2',
    'C2H6OS',
    'C6H14',
    'C10H12O2',
    'MnO2',
    'C3H6O3',
    'C4H4O6KNa·4H2O',
    'C6H12N4',
    'LiOH',
    'PCl5',
    'K2O',
    'KH2PO4',
    'AgC2H3O2',
    'Na3C6H5O7',
    'NaF',
    'NaNO2',
    'SO42−',
    'BaCO3',
    'CaI2',
    'HSO4–',
    'Li2O',
    'C4H8N2O2',
    'KMnO4',
    'Ag3PO4',
    'NH4Br',
    'Ca3(PO4)2',
    'C8H8',
    'Al2S3',
    '(NH4)2CO3',
    'BaCl2',
    'NO',
    'C6H12O6',
    'MgI2',
    'MgS',
    'O3',
    'KCN',
    'Ag2O',
    'Na2CrO4',
    'Na2O2',
    'C7H8',
    'ZnCO3',
    'Zn3(PO4)2',
    'ZnS',
    'C6H4Cl2',
    'H3BO3',
    'C2O42−',
    'KHCO3',
    'KClO',
    'KNO2',
    'C27H28Br2O5S',
    'NH4I',
    'NH4NO2',
    '(NH4)2O',
    'Ar',
    'BaBr2',
    'BaI2',
    'BrO3–',
    'N2O3',
    'C2H6O2',
    'NiSO4',
    'He',
    'I–',
    'Pb(C2H3O2)2',
    'LiCl',
    'KSCN',
    'C4H10',
    'C12H22O11',
    'C27H36N2O10',
    'CH2O',
    'HCOOH',
    'SF6',
    'PCl3',
    'C2H6',
    'N2O5',
    'H3PO3',
    'K4Fe(CN)6',
    'XeF2',
    'Br2',
    'C6H5',
    'PI3',
    'H2S2O8',
    'K2HPO4',
    'Al(OH)3',
    '(NH4)2S2O8',
    'Na2[B4O5(OH)4]·8H2O',
    'C2H3O2Cl',
    'CH3CO2K',
    'BaO',
    'Cu2O',
    'Cu(OH)2',
    'SnO2',
    'ClF3',
    'C2H4',
    'C2H2',
    'Cr2O3',
    'NaHSO4',
    'CuCl2',
    'HgCl2',
    'SnCl2',
    'C3H8',
    'PbO2',
    'H2O',
    'NaCl',
    'CO2',
    'NH3',
    'HCl',
    'H2SO4',
    'HNO3',
    'CH4',
    'CaCO3',
    'NaOH',
    'C2H5OH',
    'C6H12O6',
    'CH4',
    'C2H4',
    'C6H6',
    'CH3COOH',
    'C9H8O4',
    'C2H5NO2',
    '(C5H10O4)n',
    'C8H10N4O2',
    'H+',
    'OH-',
    'Na+',
    'Cl-',
    'K+',
    'Ca2+',
    'NO3-',
    'SO4^2-',
    'NH4+',
    'PO4^3-',
    'H',
    'O',
    'C',
    'N',
    'Na',
    'Cl',
    'Fe',
    'Au',
    'Ag',
    'U',
    'H2O', 'O2', 'C', 'N2', 'Na', 'Cl2', 'Fe', 'Au', 'Hg', 'U',
    'H2SO4', 'NaCl', 'CO2', 'NH3', 'H2SO4', 'CaCO3', 'HCl', 'NaOH', 'KNO3',
    'CH4', 'C2H5OH', 'C6H12O6', 'C10H13N2O5P', 'C9H8O4', 'C8H10N4O2', 'C8H9NO2', 'C3H8', 'C6H6',
    'FeSO4', 'K2Cr2O7', 'AgNO3', 'CuSO4', 'MnO2', 'ZnO',
    'NH4OH', 'CuSO4', 'KNO3', 'Na2CO3', 'BaS', 'FeSO4',
    'OH-', 'NO3-', 'CO3^2-', 'SO4^2-', 'PO4^3-', 'NH4+',
    'C6H8O6', 'C28H44O', 'C63H88CoN14O14P2', 'C20H30O', 'C29H50O2',
    'NaHCO3', 'C5H8NNaO4', 'C7H5NO3S', 'C7H5NaO2',
    'C2H4', 'C3H6', 'C4H6', 'C6H6', 'C7H8',
    'C7H8', 'C6H5OH', 'C6H5NH2', 'C8H8', 'C10H8', 'C7H6O', 'C8H10',
    'C3H7NO2', 'C5H10N2O3', 'C6H14N2O2', 'C9H11NO2', 'C2H5NO2', 'C3H7NO3',
    'C6H8O6', 'C2H5NH2', 'C2H4O', 'C5H5N', 'C3H5NO', 'C4H8O',
    'C3H5NO2', 'C3H3N', 'C2H3Cl', 'C3H5NO2',
    'C2H4O', 'C3H6', 'C4H6', 'C4H4', 'C6H6',
    'C6H7NO4', 'C5H7NO3', 'C7H10NO5', 'C11H16O3',
    'C3H6', 'C4H6', 'C7H10N5O2S', 'CxHyNzOP', 'CxHyOz',
    'C2H4', 'C3H6', 'C4H6', 'C6H6', 'C7H8',
    'KMnO4', 'Na2CO3', 'CaO', 'AlN', 'SiO2',
    'Ni(CO)4', 'Cu(NH3)4(H2O)2', 'Pt(NH3)4][PtCl4]',
    'CH3OH', 'C2H5OH', 'C3H7OH', 'C5H12O3', 'C3H8O3',
    'C19H28O2', 'C18H24O2', 'C15H11I4NO4', 'C21H30O5',
    'C7H8', 'C8H10', 'C10H8', 'C14H10', 'C14H10',
    'BHA', 'Na2SO3', 'C6H7NaO7', 'C64H124O26',
    'C2H4', 'C3H6', 'C4H6', 'C6H6', 'C7H8',
    'CH3OH', 'C2H4O', 'C4H6', 'C7H8', 'C10H16O',
    'CH3OH', 'C2H5OH', 'C3H7OH', 'C4H10O2', 'C5H8O2',
    'C3H6', 'C7H8', 'C8H8', 'C8H8', 'C7H6',
    'C9H8O4', 'C2H4O', 'C3H6', 'C4H6', 'C5H6',
    'C14H14O2', 'C7H7N', 'C6H8O6', 'C12H12O4',
    'C4H10', 'C6H14', 'C3H7N', 'C2H5NO2', 'C6H7NO2',
    'C10H14N5O7P', 'C27H38N3O7', 'C11H24O', 'C18H22N2O', 'CH3',
    'C2H5', 'C3H7', 'C4H10', 'C5H12', 'C6H14', 'CaCl2',

];